<template>
<div class="month-picker">
    <div v-for="(item, key) in items" class="month-item" :class="{selected: value== key}" @click="select(key)">{{item}}</div>
</div>
</template>

<script type="text/javascript">
import ui from '../base/ui'

const months = {
    '1': '一月',
    '2': '二月',
    '3': '三月',
    '4': '四月',
    '5': '五月',
    '6': '六月',
    '7': '七月',
    '8': '八月',
    '9': '九月',
    '10': '十月',
    '11': '十一月',
    '12': '十二月'
}

export default {
    mixins: [ui],
    params: {
        value: 1,
        items: months
    },
    methods: {
        select(idx) {
            this.emit('value-change', {value: idx})
        }
    }
} 

</script>

<style type="text/css" lang="less">
.month-picker {
    max-width: 280px;
    height: 170px;
    border-right: 1px solid #EEE;
    border-bottom: 1px solid #EEE;
    position: absolute;
    left: 0;
    width: 100%;
    background: #FFF;
    z-index: 7;
    .month-item {
        display: inline-block;
        width: 25%;
        height: 33.1%;
        line-height: 50px;
        text-align: center;
        vertical-align: middle;
        border-left: 1px solid #EEE;
        border-top: 1px solid #EEE;
        cursor: pointer;
        color: #26c899;
        &.selected,
        &:hover {
            background-color: #26c899;
            color: #FFF;
        }
    }
}

</style>


// WEBPACK FOOTER //
// MonthPicker.vue?8e178084